<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-07-28 17:37:34
 * @LastEditors: sjq
 * @LastEditTime: 2023-08-08 15:08:28
 -->
<template>
  <div class="minheight100" style="padding-bottom: 95px" v-if="dataDetail">
    <app-header v-if="appUser.isNative" back-type="back-app" title="友邻少年"></app-header>
    <div class="head_bg">
      <img :src="dataDetail.activityCover" alt="" class="" />
    </div>
    <div class="content-border-top">
      <div class="line-border"></div>
    </div>
    <div class="share-content">
      <div class="s-title" v-if="!examineData">选择奖品</div>
      <div class="my-swiper" :class="{ 'good-list-center': dataDetail.rewardGoodsList.length === 1 }">
        <div v-for="(item, index) in dataDetail.rewardGoodsList" :key="index" class="good-list">
          <div v-if="examineData" class="receive-icon">
            <img src="./images/receive-icon.png" alt="" />
          </div>
          <!-- 0 实物  1 积分  2 专辑   4 礼品卡 5 自定义 -->
          <div class="card-award" v-if="item.type === '90001'">
            <div class="card-con">
              <div class="con-img">
                <img :src="item.realGoodsImg" v-if="item.realGoodsImg" />
                <img src="./images/good_default.png" alt="" v-else />
              </div>
            </div>
            <div class="zd">
              <div class="line2">
                {{ item.goodsName }}
              </div>
            </div>
            <div
              class="btn-common"
              :class="{ 'btn-disabled': item.sendOver }"
              @click="receive(item)"
              v-if="!examineData"
            >
              {{ item.sendOver ? '奖品已领完' : '立即领取' }}
            </div>
          </div>
          <div class="card-award1" v-else-if="item.type === 'credit'">
            <div class="card-con">
              <div class="text">
                {{ item.num }}
              </div>
            </div>
            <div class="zd zd-big" v-if="examineData">积分</div>
            <div class="zd zd-big-btn" v-else>
              <div class="btn-common" :class="{ 'btn-disabled': item.sendOver }" @click="receive(item)">
                {{ item.sendOver ? '奖品已领完' : '立即领取积分奖励' }}
              </div>
            </div>
          </div>
          <div class="card-award3" v-else-if="item.type === '20001'">
            <div class="con-img">
              <img :src="item.albumCover" />
            </div>
            <div class="card-content">
              <div class="title">
                {{ item.goodsName }}
              </div>
              <div class="num">共 {{ item.courseCount }} 节</div>
              <div class="day">{{ item.equityDays }} 天内有效</div>
              <div
                class="btn-common"
                :class="{ 'btn-disabled': item.sendOver }"
                @click="receive(item)"
                v-if="!examineData"
              >
                {{ item.sendOver ? '奖品已领完' : '立即领取' }}
              </div>
            </div>
          </div>
          <div class="card-award4" v-else-if="item.type === '60001'">
            <div class="card-con">
              <div class="con-img">
                <img :src="item.giftCardImg" />
              </div>
            </div>
            <div class="zd">
              <div class="title">
                {{ item.goodsName }}
              </div>
              <div class="data">
                {{
                  item.termType == 1
                    ? item.useStartDate.split('T')[0].replace(/-/g, '.') +
                      '-' +
                      item.useEndDate.split('T')[0].replace(/-/g, '.') +
                      '有效'
                    : '领取后' + item.dayUse + '天内有效'
                }}
              </div>
              <div
                class="btn-common"
                :class="{ 'btn-disabled': item.sendOver }"
                @click="receive(item)"
                v-if="!examineData"
              >
                {{ item.sendOver ? '奖品已领完' : '立即领取' }}
              </div>
            </div>
          </div>
          <div class="card-award5" v-else-if="item.type === '10010'">
            <div class="con-img">
              <img :src="item.realGoodsImg" />
            </div>
            <div class="card-content">
              <div class="title">
                {{ item.goodsName }}
              </div>
              <div class="content">
                {{ item.goodsDescription }}
              </div>
              <!-- <div class="price">价值{{ item.goodsPrice }}元</div> -->
              <div
                class="btn-common"
                :class="{ 'btn-disabled': item.sendOver }"
                @click="receive(item)"
                v-if="!examineData"
              >
                {{ item.sendOver ? '奖品已领完' : '立即领取' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="btn-common btn-common-bottom block"
        v-if="examineData"
        :class="{ 'btn-disabled': false }"
        @click="lookProgress"
      >
        查看领取进度
      </div>
      <!-- <div class="btn-common block" v-else :class="{ 'btn-disabled': false }" @click="receive">立即领取</div> -->
      <div class="rule-commit" v-if="dataDetail.showRuleDesc === 1">
        <div class="title">规则说明：</div>
        <div class="content" v-html="dataDetail.activityRuleDesc"></div>
      </div>
    </div>

    <div class="share" v-if="!appUser.isNative && dataDetail.shareActivityId" @click="goActivity">
      <img src="./images/share_poster.png" alt="" />
    </div>
    <Popup v-model="show" class="border-message-popup">
      <div class="message-popup">
        <div>{{ messageData.mainTitle || '活动已结束' }}</div>
        <div>{{ messageData.secondTitle || '活动已经结束了，下次再来吧~' }}</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'

const action = 'shareActivity'

export default {
  name: action,
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    Popup
  },
  data() {
    return {
      appUser,
      swiperKey: Math.random().toString(36).substr(2) /*随机的key*/,
      title: '友邻少年',
      dataDetail: {
        rewardGoodsList: []
      },
      examineData: null,
      activityIndex: 0,
      show: false,
      messageData: {}
    }
  },
  mixins: [Body],
  created() {
    this.activityId = this.$route.query.activityId
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.activityVerify(false)
  },
  activated() {},
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mounted() {},

  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.activityVerify(false)
      })
    },
    //详情
    getData() {
      activityService
        .shareActivityDetail({
          shareCode: this.shareCode,
          activityId: this.activityId
        })
        .then(res => {
          console.log(res, 'res')
          this.dataDetail = res.activityInfo
          this.examineData = res.examineData
          if (this.examineData) {
            this.dataDetail.rewardGoodsList = [
              this.dataDetail.rewardGoodsList.find(item => item.goodsId == this.examineData.rewardGoodsId)
            ]
          }
        })
        .catch(err => {
          this.dataDetail = err.data
        })
    },
    // 领取
    receive(data) {
      if (data.sendOver) {
        if (data.type === 'credit') {
          Toast('奖品已领完')
        }
        return
      }
      if (data.type !== 'credit') {
        if (data.status === '11') {
          Toast('该商品未上架')
          return
        } else if (data.status !== '10') {
          Toast('该商品已下架')
          return
        }
      }
      activityService
        .shareActivityVerify({
          activityId: this.dataDetail.activityId,
          rewardGoodsId: data.goodsId
        })
        .then(res => {
          console.log(res, ';;;;')
          this.$router.push({
            name: 'shareActivitySubmit',
            query: {
              activityId: this.dataDetail.activityId,
              rewardGoodsId: data.goodsId
            }
          })
        })
        .catch(err => {
          if ([30122, 30433, 30432, 30431].indexOf(err.code) !== -1) {
            this.show = true
            this.messageData = err.data
            if (err.code === 30431) {
              this.messageData = {
                mainTitle: err.message,
                secondTitle: '请联系班主任'
              }
            }
          }
        })
    },
    activityVerify(needGoods = true) {
      let data = {}
      if (needGoods) {
        data = {
          activityId: this.dataDetail.activityId,
          rewardGoodsId: this.dataDetail.rewardGoodsList[0].goodsId,
          needGoods
        }
      } else {
        data = {
          activityId: this.activityId,
          shareCode: this.shareCode,
          needGoods
        }
      }
      activityService
        .shareActivityVerify(data)
        .then(res => {
          if (needGoods) {
            this.$router.push({
              name: 'shareActivitySubmit',
              query: {
                activityId: this.dataDetail.activityId,
                rewardGoodsId: this.dataDetail.rewardGoodsList[0].goodsId
              }
            })
          } else {
            this.getData()
          }
        })
        .catch(err => {
          if ([30122, 30433, 30432, 30431].indexOf(err.code) !== -1) {
            this.show = true
            this.messageData = err.data
            if (err.code === 30431) {
              this.messageData = {
                mainTitle: err.message,
                secondTitle: '请联系班主任'
              }
            }
          }
          if (!needGoods) {
            this.getData()
          }
        })
    },
    // chakan
    lookProgress() {
      this.$router.push({
        name: 'shareActivityResult',
        query: {
          activityId: this.examineData.activityId,
          rewardGoodsId: this.examineData.rewardGoodsId
        }
      })
    },
    goActivity() {
      location.href = this.dataDetail.applyActivityUrl
    },
    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.my-swiper {
  width: 100%;
  padding: 16px 0 26px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
}
.receive-icon {
  width: 96px;
  height: 96px;
  position: absolute;
  bottom: 0;
  right: 0px;
  z-index: 999;
  img {
    width: 100%;
    height: 100%;
  }
}
.good-list {
  display: inline-block;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 10px 24px 0px rgba(17, 0, 0, 0.1);

  margin-left: 16px;
  position: relative;
  > div {
    border-radius: 8px;
    overflow: hidden;
  }
  &:last-child {
    margin-right: 16px;
  }
  .receive-icon {
    width: 96px;
    height: 96px;
    position: absolute;
    bottom: -12px;
    right: -12px;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.head_bg {
  width: 100%;
  // height: 33vh;
  background: #00b25a;
  img {
    width: 100%;
  }
}
.content-border-top {
  margin-top: -34px;
  position: relative;
  overflow: hidden;
  .line-border {
    height: 34px;
    border-radius: 34px 34px 0 0;
    margin: 0 -10px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.4);
  }
}
.share-content {
  background: #fff;
  padding-top: 30px;
  border-radius: 24px 24px 0 0;
  margin-top: -24px;
  position: relative;
  min-height: calc(100vh - 33vh);
}
.card-award {
  width: 160px;
  .card-con {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    .con-img {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .zd {
    width: 100%;
    min-height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    line-height: 22px;
  }
  .btn-common {
    margin: 8px auto 12px;
  }
}
.card-award1 {
  width: 80vw;
  height: 140px;
  background-color: #dcad7e;
  padding: 6px;
  position: relative;
  .card-con {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    height: 80px;
    background: #fff7eb;
    .text {
      color: #fb5c51;
      font-size: 48px;
      font-weight: bold;
    }
  }
  .zd {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-image: url('./images/zd_small.png');
    background-size: 100% 100%;
    text-align: center;
    color: #974f07;
    font-size: 14px;
    padding-top: 22px;
  }
  .zd-big {
    background-image: url('./images/zd_big.png');
    height: 79px;
    padding-top: 45px;
  }
  .zd-big-btn {
    background-image: url('./images/zd_big.png');
    height: 79px;
    padding-top: 35px;
  }
  .btn-common {
    border: 1px solid rgba(151, 79, 7, 0.5);
    color: #974f07;
    font-size: 14px;
    font-weight: 500;
    background: transparent;
    width: 136px;
    height: 32px;
    line-height: 32px;
    padding: 0px 12px;
  }
}
.card-award3 {
  width: 300px;
  height: 120px;
  display: flex;
  .con-img {
    width: 90px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .card-content {
    padding: 8px 12px 12px 12px;
    flex: 1;
    position: relative;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .num {
      color: #999;
      line-height: 16px;
      font-size: 14px;
    }
    .day {
      display: inline-block;
      position: absolute;
      bottom: 14px;
      left: 12px;
      color: #999;
      font-size: 14px;
    }
    .btn-common {
      position: absolute;
      bottom: 14px;
      right: 12px;
    }
  }
}
.card-award4 {
  border-radius: 8px;
  background: #e6e6e6;
  width: 300px;
  position: relative;
  .card-con {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 153px;
    .con-img {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .zd {
    width: 100%;
    background: #fff;
    padding: 12px 16px 16px;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .data {
      color: #999;
    }
  }
  .btn-common {
    position: absolute;
    bottom: 14px;
    right: 12px;
  }
}
.card-award5 {
  width: 300px;
  border-radius: 8px;
  height: 120px;
  display: flex;
  background: #fff;
  .con-img {
    width: 120px;
  }
  .card-content {
    padding: 8px 12px 12px 12px;
    flex: 1;
    position: relative;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .content {
      color: #999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      max-height: 33px;
      line-height: 16px;
      font-size: 14px;
    }
    .price {
      position: absolute;
      bottom: 12px;
      color: #00b25a;
    }
    .btn-common {
      position: absolute;
      bottom: 14px;
      right: 12px;
    }
  }
}
.good-list-center {
  display: flex;
  justify-content: center;
  .good-list {
    margin: 0;
  }
}
.s-title {
  color: #00b25a;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  &::before {
    content: '';
    display: inline-block;
    height: 16px;
    width: 58px;
    background: url('./images/title_icon.png') no-repeat;
    background-size: 100% 100%;
    vertical-align: bottom;
  }
  &::after {
    content: '';
    display: inline-block;
    height: 16px;
    width: 58px;
    background: url('./images/title_icon.png') no-repeat;
    background-size: 100% 100%;
    transform: rotateY(180deg);
    vertical-align: bottom;
  }
}
.rule-commit {
  margin: 16px;
  padding: 16px;
  border-radius: 8px;
  background: #f5f5f5;
  .title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 8px;
  }
  .content {
    line-height: 22px;
  }
}
.btn-common {
  width: 72px;
  height: 25px;
  line-height: 25px;
  border-radius: 23px;
  font-size: 12px;
  padding: 0px 12px;
  border: none;
}
.btn-common-bottom {
  display: block;
  width: 232px;
  height: 50px;
  border-radius: 25px;
  margin: 40px auto;
  font-size: 16px;
  line-height: 50px;
  padding: 0 12px;
}

.share {
  position: fixed;
  bottom: 50px;
  right: 0;
  width: 100px;
  height: 66px;
}
.message-popup {
  min-width: 310px;
  padding: 40px 56px;
  color: #999;
  text-align: center;
  div:first-child {
    margin-bottom: 12px;
    color: #000;
    font-size: 18px;
    font-weight: bold;
  }
}
.btn-disabled {
  width: 84px;
  background: #b8bfbf;
  color: #fff;
}
</style>
